export const ERROR_MESSAGES = {
  name: 'Name is required',
  ageGender: 'Age/Gender is required',
  doctor: 'Doctor is required',
  department: 'Department is required',
  ratePlan: 'Rate Plan is required',
  mrNo: 'MR No is required',
  visitId: 'Visit ID is required',
  admissionDate: 'Admission Date is required',
  dischargeDate: 'Discharge Date is required',
  wardBed: 'Ward/Bed is required',
  source: 'Source is required',
  finalDiagnosis: 'Final Diagnosis is required',
  history: 'History is required',
  investigationsDone: 'Investigations Done is required',
  treatmentGiven: 'Treatment Given is required',
  progressInHospital: 'Progress in Hospital is required',
  treatmentAdvised: 'Treatment Advised is required',
  preventiveCare: 'Preventive Care is required',
  diet: 'Diet is required',
  daysAfter: 'Days After is required',
  symptom: 'Symptom is required',
  preparedByDoctor: 'Prepared By Doctor is required',
  preparedBySignature: 'Prepared By Signature is required',
  preparedByDate: 'Prepared By Date is required',
  treatingDoctor: 'Treating Doctor is required',
  treatingDoctorRegNo: 'Treating Doctor Registration No is required',
  treatingDoctorSignature: 'Treating Doctor Signature is required',
}

export const patientDetails = [
  { label: 'Name', name: 'name', type: 'text' },
  { label: 'Age/Gender', name: 'ageGender', type: 'text' },
  { label: 'Location', name: 'locationAddress', type: 'text' },
  { label: 'Doctor', name: 'doctor', type: 'text' },
  { label: 'Department', name: 'department', type: 'text' },
  { label: 'Rate Plan', name: 'ratePlan', type: 'text' },
  { label: 'MR No', name: 'mrNo', type: 'text' },
  { label: 'Visit ID', name: 'visitId', type: 'text' },
  { label: 'Admission Date', name: 'admissionDate', type: 'date' },
  { label: 'Discharge Date', name: 'dischargeDate', type: 'date' },
  { label: 'Ward/Bed', name: 'wardBed', type: 'text' },
  { label: 'Source (Insurance Plan)', name: 'source', type: 'text' },
]

export const patientDischargeSummmary = [
  { label: 'Final Diagnosis', name: 'finalDiagnosis', type: 'text' },
  { label: 'History', name: 'history', type: 'text' },
]

export const physicalExamFields = [
  { label: 'O/E', name: 'oe', type: 'text' },
  { label: 'BP', name: 'bp', type: 'text' },
  { label: 'PR', name: 'pr', type: 'text' },
  { label: 'SPO2', name: 'spo2', type: 'text' },
  { label: 'TEMP', name: 'temp', type: 'text' },
  { label: 'CVS', name: 'cvs', type: 'text' },
  { label: 'RS', name: 'rs', type: 'text' },
  { label: 'P/A', name: 'pa', type: 'text' },
  { label: 'CNS', name: 'cns', type: 'text' },
]

export const physicalInvestigation = [
  { name: 'investigationsDone', label: 'Investigations Done', type: 'text' },
  {
    name: 'treatmentGiven',
    label: 'Treatment Given in Hospital',
    type: 'text',
  },
  { name: 'progressInHospital', label: 'Progress in Hospital', type: 'text' },
  { name: 'treatmentAdvised', label: 'Treatment Advised', type: 'text' },
  { name: 'preventiveCare', label: 'Preventive Care', type: 'text' },
  { name: 'diet', label: 'Diet', type: 'text' },
]

export const dataTypes = {
  STRING: 'string',
  DATE: 'date',
}
